import React, {  Component } from 'react';

export default class PhoneNumberUpdatedOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="phoneNumberUpdatedOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Update Complete</h2>
                    <p className="importantText bold">{this.props.message?this.props.message:"Your phone number has been successfully updated."}</p>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/phoneNumberUpdatedOverlayDialog.js